import React from "react";
import starRating from "../../assets/images/pages/home/rating/star_rating.svg";
import appleStore from "../../assets/images/pages/home/applestore.svg";
import googleStore from "../../assets/images/pages/home/googlestore.svg";

const AppStoreLinks = () => (
  <div className="app-link-apple">
    <a
      href="https://www.apple.com/in/app-store/"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img
        src={appleStore}
        alt="Download on the Apple App Store"
        className="rating__box__img-logo"
      />
    </a>
    <a
      href="https://play.google.com/store"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img
        src={googleStore}
        alt="Get it on Google Play"
        className="rating__box__img-logo"
      />
    </a>
  </div>
);

const RatingBox = () => (
  <div className="rating__box">
    <h1 className="rating__box-head text-jost-sb-50-wt txt-center">
      Timely Golf are loving us. You will too.
    </h1>
    <div className="rating__box-star">
      <img
        src={starRating}
        className="rating__box-star-icon"
        alt="Star Rating Icon"
      />
    </div>
    <p className="text-ops-rg-22-wt">4.7 / 5 rating on the App Store</p>
    <AppStoreLinks />
  </div>
);

const TeeRating = () => {
  return (
    <section className="section-p">
      <div className="page-width">
        <div className="rating">
          <RatingBox />
        </div>
      </div>
    </section>
  );
};

export default TeeRating;
